import { PayoutMethod } from '@/types/api/payout-account';
import { RadioGroupItem } from '../ui/radio-group';
import PayoutMethodIcon from '@/partials/group/settings/payout/PayoutMethodIcon';
import { Label } from '../ui/label';

const methodTextMapping = {
  [PayoutMethod.Swish]: {
    label: 'Swish',
    text: 'Vi swishar direkt ut till ett svenskt mobilnummer.',
  },
  [PayoutMethod.BankTransfer]: {
    label: 'Bankkonto',
    text: 'Vi gör banköverföringar till ert bankkonto.',
  },
};

interface PayoutMethodRadioCardProps {
  payoutMethod: PayoutMethod;
}

export default function PayoutMethodRadioCard({ payoutMethod }: PayoutMethodRadioCardProps) {
  return (
    <div className="relative flex w-full items-start gap-2 rounded-lg border border-input p-4 shadow-sm shadow-black/5 has-[[data-state=checked]]:border-gray-600">
      <RadioGroupItem
        value={payoutMethod}
        id="radio-09-r1"
        aria-describedby="radio-09-r1-description"
        className="order-1 after:absolute after:inset-0"
      />
      <div className="flex grow items-start gap-3">
        <PayoutMethodIcon payoutMethod={payoutMethod} />
        <div className="grid grow gap-2">
          <Label htmlFor="radio-09-r1">{methodTextMapping[payoutMethod].label} </Label>
          <p id="radio-09-r1-description" className="text-xs text-muted-foreground">
            {methodTextMapping[payoutMethod].text}
          </p>
        </div>
      </div>
    </div>
  );
}
